module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1522-6dde2f38002156a39ed31966e2d9cf14.png";